'use client'

import { HttpAction, HttpStateData } from '@/clients/http'
import { HttpState } from '@/clients/redux/reducers/http'
import {
  performHttpCall,
  resetHttpState,
  resetHttpStates,
} from '@/clients/redux/reducers/http/httpSlice'
import { store } from '@/clients/redux/store'

export async function createHttpRequest<Data, Error>(
  options: HttpAction
): Promise<HttpStateData<Data, Error>> {
  const response: any = await store.dispatch(performHttpCall(options))
  const success = !response?.error || response?.meta?.requestStatus === 'rejected'

  return {
    correlationKey: response?.meta?.arg?.correlationKey,
    loading: false,
    success,
    error: !success ? (response?.payload?.response ?? response?.payload) : false,
    payload: response?.meta?.arg?.payload?.body,
    data: success ? (response?.payload?.data ?? null) : null,
  } as HttpStateData<Data, Error>
}

export function clearAllHttpStateObjects() {
  store.dispatch(resetHttpStates({}))
}

export function clearHttpStateObject(coreRelationKey: keyof HttpState, data: any = null) {
  store.dispatch(
    resetHttpState({
      coreRelationKey,
      data,
    })
  )
}

export function getHttpState<Data, Error>({
  correlationKey,
}: {
  correlationKey: string
}): HttpStateData<Data, Error> | null {
  return (store.getState().http[correlationKey] ?? null) as HttpStateData<Data, Error> | null
}
